export default {
  id: "roamSales",
  name: "",
  description: "",
  report: {
    name: "Roam Sales",
    chartType: "COLUMN",
    template: "custom",
    config: {
      dataSet: "Sale",
      dataType: "time_series",
      dimensions: [],
      measures: ["Sale.total_revenue"],
      sort: {
        direction: null,
        by: null,
      },
      timeDimension: "Sale.sale_time",
      timeGranularity: "day",
      filters: [
        {
          member: "Sale.source",
          operator: "equals",
          values: ["5"],
        },
      ],
      compare: true,
      limit: "999",
      rowTotals: false,
      points: false,
      colorTheme: "default",
    },
  },
};
